import { render, staticRenderFns } from "./Embajador.vue?vue&type=template&id=4410ee98"
import script from "./Embajador.vue?vue&type=script&lang=js"
export * from "./Embajador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports